//region :: Imports ::
import MComponent from '../Component';
import {ErrorIcon} from '../../Icons';
import React, {ReactElement} from 'react';
import MButton from './Button';
import {navigateToRoot, reloadPage} from '../../Utils';

//endregion

/** */
type Props = {
    message: string;
}

/** */
class MBlockUIErrorTemplate extends MComponent<Props> {

    /** */
    public render(): ReactElement {

        const defaultClasses = 'flex justify-content-center align-items-center mb-3';

        return (
            <div className="flex flex-column justify-content-center align-content-center">

                {/* Icon */}
                <div className={`${defaultClasses}`}>
                    <i className={`${ErrorIcon.name} ${ErrorIcon.color} text-7xl`}/>
                </div>

                {/* Message */}
                <div className={`${defaultClasses} text-4xl`}>
                    <span className="mtext-lock-message-color">{this.props.message}</span>
                </div>

                {/* Caption 1 */}
                <div className={`${defaultClasses} text-xl mtext-lock-caption-color`}>
                    This error has caused the state of the page to become invalid. Refresh the page and try again.
                </div>

                {/* Caption 2 */}
                <div className={`${defaultClasses} text-xl mtext-lock-caption-color`}>
                    If the problem continues, then please report the issue to&nbsp;<strong>support@mjquinn.co.uk</strong>.
                </div>

                {/* Options */}
                <div className={`${defaultClasses} mt-4`}>
                    <div className="mr-3">
                        <MButton icon="pi-home"
                                 iconOnly={true}
                                 size="lg"
                                 tooltip="Navigate to Home page"
                                 disabled={false}
                                 onClick={() => navigateToRoot()}/>
                    </div>
                    <div>
                        <MButton icon="pi-refresh"
                                 iconOnly={true}
                                 size="lg"
                                 tooltip="Refresh the page"
                                 disabled={false}
                                 onClick={() => reloadPage()}/>
                    </div>
                </div>

            </div>
        );

    }

}

export default MBlockUIErrorTemplate;
